import { render } from "./checkoutDetail.vue?vue&type=template&id=146b91a2"
import script from "./checkoutDetail.vue?vue&type=script&lang=js"
export * from "./checkoutDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__